import React, { useState, useEffect } from "react";
import "./Recon.css";
import ReconTransaction from "./ReconTransaction";
import { ShimmerSimpleGallery } from "react-shimmer-effects";

function TransactionList({
  excelData,
  setAddedDataForRecon,
  addedDataForRecon,
  setShowZyroList,
  setShowOurList,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(true);
  const seenRRNs = new Set();

  useEffect(() => {
    const allDataLoaded = excelData.every(
      (row) => row.transactionDetails && row.transactionDetails.length > 0
    );
    if (allDataLoaded) {
      setIsLoading(false);
    }
  }, [excelData]);

  const handleSelectOrRemoveAll = () => {
    if (selectAll) {
      const allTransactions = excelData.flatMap(
        (row) => row.transactionDetails || []
      );
      setAddedDataForRecon(allTransactions);
    } else {
      setAddedDataForRecon([]);
    }
    setSelectAll((prev) => !prev);
  };

  return (
    <div>
      <div className="out-head">
        <h2 className="area-top-title-pay-out">Transactions List</h2>
        <button
          className="select-all-btn"
          onClick={handleSelectOrRemoveAll}
          disabled={isLoading}
          style={{
            opacity: isLoading ? 0.5 : 1,
            cursor: isLoading ? "not-allowed" : "pointer",
          }}
        >
          {selectAll ? "Select All" : "Remove All"}
        </button>
      </div>

      <div className="dashboard-page-container">
        {excelData.map((row, index) => {
          const isRepeated = seenRRNs.has(row.RRN);
          seenRRNs.add(row.RRN);

          return (
            <div key={index} className="dashboard-row-container">
              <div
                className={`dashboard-row-label ${
                  isRepeated ? "repeated-entry" : ""
                }`}
              >
                <h3>
                {isRepeated ? `${index + 1} (Repeated)` : index + 1}
                  <ul>
                    <li>Name - {row.Payer}</li>
                    <li>Amount - {row.Amount}</li>
                    <li>RRN - {row.RRN}</li>
                    <li>Status - {row.Status}</li>
                    <li>Date - {row["TXN DATE"]}</li>
                    <li>Type - {row.Type}</li>
                    <li>Vpa - {row.VPA}</li>
                  </ul>
                </h3>
              </div>

              <div className="dashboard-table-container">
                {row.transactionDetails && row.transactionDetails.length > 0 ? (
                  <ReconTransaction
                    transactionDetails={row.transactionDetails}
                    setAddedDataForRecon={setAddedDataForRecon}
                    addedDataForRecon={addedDataForRecon}
                  />
                ) : (
                  <ShimmerSimpleGallery
                    className="shimmer-effect"
                    row={1}
                    col={1}
                    imageHeight={300}
                  />
                )}
              </div>
            </div>
          );
        })}

        <div className="review">
          <button
            className="addUser-btn"
            onClick={() => {
              setShowZyroList(false);
              setShowOurList(true);
            }}
          >
            Review Changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default TransactionList;